<div class="row">
    <ng-container *ngIf="!viewingClones; else versionTitle">
        <div class="col-md-6">
            <h4>Lista de megatendencias</h4>
        </div>
    </ng-container>
    <ng-template #versionTitle>
        <div class="d-flex justify-content-start align-items-center w-100 mb-3">
            <button class="btn btn-sm btn-outline-secondary me-3" (click)="goBackToGeneralList()">
                <i class="fa fa-arrow-left" aria-hidden="true"></i> Volver
            </button>
            <div class="flex-grow-1 text-center">
                <h4> Historial de versiones : {{ filteredData[0].code }} - {{ filteredData[0].longtitle }} </h4>
            </div>
        </div>
    </ng-template>

    <div *ngIf="!viewingClones" class="col-sm-6 text-end">
        <ng-container *ngIf="createDoc===true">
            <a [routerLink]="['../add-info/' + idmegatendencia]" class="btn-add">
                <i class="fa fa-plus px-2"></i> Agregar documentos
            </a>
        </ng-container>
        <ng-container *ngIf="createGI===true">
            <a [routerLink]="['../add-interrelationship-graph/' + idmegatendencia]" class="btn-add">
                <i class="fa fa-snowflake-o" aria-hidden="true"></i> Gráfico de interrelación
            </a>
        </ng-container>
        <ng-container *ngIf="accessMP===true">
            <a [routerLink]="['../add', selectedT1]" class="btn-add">
                <i class="fa fa-plus px-2"></i> Agregar nueva megatendencia
            </a>
        </ng-container>
    </div>
    <div class="container my-1">
        <div class="filter-bar row g-1 p-3">
            <div class="col-12 col-md-6">
                <input type="text" [(ngModel)]="filters.searchText" placeholder="Buscar por nombre largo o código"
                    (input)="applyFilter()" class="form-control filter-input" />
            </div>
            <div class="col-12 col-md-3">
                <select [(ngModel)]="filters.tematica" (change)="applyFilter()" class="form-select filter-select">
                    <option value="">Todas las temáticas</option>
                    <option *ngFor="let t of tematic" [value]="t.title">{{ t.title }}</option>
                </select>
            </div>
            <div class="col-12 col-md-3">
                <select [(ngModel)]="filters.estado" (change)="applyFilter()" class="form-select filter-select">
                    <option [ngValue]="null">Todos los estados</option>
                    <option [ngValue]="true">Activo</option>
                    <option [ngValue]="false">Inactivo</option>
                </select>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="table-responsive">
        <table class="table table-hover">
            <thead class="thead-detail text-center table-success">
                <tr>
                    <th scope="col">N°</th>
                    <th scope="col">Código</th>
                    <th scope="col">Nombre largo</th>
                    <th scope="col">Versión</th>
                    <ng-container *ngIf="!viewingClones">
                        <th scope="col">Temática</th>
                        <th scope="col">Actualización</th>
                        <th scope="col">Estado</th>
                        <th scope="col">Ficha</th>
                        <th scope="col">Secciones</th>
                        <th scope="col">Gráficos</th>
                        <th scope="col">Bibliografía</th>
                        <th scope="col">Fuente primaria</th>
                        <ng-container *ngIf="accessME===true">
                            <th scope="col" style="min-width: 40px;"></th>
                        </ng-container>
                        <ng-container *ngIf="accessLog">
                            <th scope="col" style="min-width: 40px;"></th>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="viewingClones">
                        <th scope="col">Activo hasta</th>
                    </ng-container>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let obj of filteredData; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td class="text-center">{{ obj.code }}</td>
                    <td class="text-left">
                        <a class="a-link-ficha" [routerLink]="viewingClones 
                        ? '/ficha-historial/' + obj.id 
                        : (obj.status ? '/ficha/' + obj.code : '/ficha-test/' + obj.id)" target="_blank"
                            (click)="setView('link')">
                            {{ obj.longtitle }}
                        </a>
                    </td>
                    <ng-container *ngIf="!viewingClones">
                        <td class="text-center">
                            <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="versionDropdown"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    {{ obj.version }}
                                </button>
                                <ul *ngIf="!viewingClones" class="dropdown-menu" aria-labelledby="versionDropdown">
                                    <li *ngIf="!isBlocked && !obj.isNT3 && obj.isActive">
                                        <a class="dropdown-item" (click)="cloneElement(obj.id)">Editar</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" (click)="loadVersions(obj)">Ver versiones</a>
                                    </li>
                                    <li *ngIf="obj.status">
                                        <a class="dropdown-item" (click)="setAsInactiveVersion(obj.id)">Desactivar
                                            ficha</a>
                                    </li>
                                </ul>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container *ngIf="viewingClones">
                        <td class="text-center"> {{ obj.version }}</td>
                        <td class="text-center">{{ obj.updatedAt | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                    </ng-container>
                    <ng-container *ngIf="!viewingClones">
                        <td class="text-center" [ngStyle]="{'color': obj.color}"><b>{{ obj.tematic }}</b></td>
                        <td class="text-center">{{ obj.lastUpdated | date:'MM/yyyy' }}</td>
                        <td class="text-center">
                            <div class="label-active" *ngIf="obj.status">ACTIVO</div>
                            <div class="label-inactive" *ngIf="!obj.status">INACTIVO</div>
                        </td>
                        <td class="text-center">
                            <a class="a-icon" [routerLink]="['/adm/fichas/add', obj.id]"
                                [class.disabled]="obj.isBlocked"
                                [style.pointer-events]="obj.isBlocked ? 'none' : 'auto'">
                                <i class="fa fa-file-text-o i-icon"></i>
                            </a>
                        </td>
                        <td class="text-center"><a class="a-icon" [routerLink]="['/adm/seccion/list', obj.id]"><i
                                    class="fa fa-align-justify i-icon"></i></a></td>
                        <td class="text-center"><a class="a-icon" [routerLink]="['/adm/grafico/list', obj.id]"><i
                                    class="fa fa-bar-chart i-icon"></i></a></td>
                        <td class="text-center"><a class="a-icon" [routerLink]="['/adm/bibliografia/list', obj.id]"><i
                                    class="fa fa-book i-icon"></i></a></td>
                        <td class="text-center"><a class="a-icon" [routerLink]="['/adm/fuente/list', obj.id]"><i
                                    class="fa fa-bookmark i-icon"></i></a></td>
                    </ng-container>
                    <ng-container *ngIf="accessME===true && !viewingClones">
                        <td class="text-center"><a class="a-icon" [routerLink]="['/adm/megatendencia/edit', obj.id]"><i
                                    class="fa fa-pencil i-icon"></i></a></td>
                    </ng-container>
                    <ng-container *ngIf="accessLog && !viewingClones">
                        <td class="text-center">
                            <a class="a-icon" [routerLink]="['/ficha-test', obj.id]" (click)="setView('icon')">
                                <i class="fa fa-eye i-icon"></i>
                            </a>
                        </td>
                    </ng-container>
                </tr>
            </tbody>
        </table>
    </div>
</div>